import React, { useState, useEffect, useContext, useRef } from 'react';
import * as Yup from 'yup';
import { Formik, Field } from 'formik';
import Select from 'react-select';
import { TextField } from 'formik-material-ui';
import ButtonWithLoading from '../../common/button-with-loading/ButtonWithLoading';
import { useTranslation } from 'react-i18next';
import './ContactForm.scss';
import { store } from 'react-notifications-component';
import { InputAdornment, withStyles } from '@material-ui/core';
// import EmailIcon from '../../assets/imgs/icons/mail.png';
import check from '../../assets/imgs/icons/check.png';
import juggling from '../../assets/imgs/icons/juggling.png';
import call from '../../assets/imgs/icons/call.png';
// import tax from '../../assets/imgs/icons/tax.png';
import close from '../../assets/imgs/icons/close.png';
// import passwordImg from '../../assets/imgs/icons/password.png';
import user from '../../assets/imgs/icons/user.png';
import { Modal, Button } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router';
import { useParams } from 'react-router-dom';
// import routerLinks from '../../components/app/routerLinks';
import requestProject from '../../apis/request-project-api/requestProject';
// import validateUser from '../../apis/request-project-api/validateUser';
import Countdown from 'react-countdown';
import Cookies from 'js-cookie';
import packages from '../../apis/home-api/packages';
import plusbg from '../../assets/imgs/icons/plusbg.png';
import mins from '../../assets/imgs/icons/mins.png';
import discount from '../../apis/home-api/discount';
import information from '../../apis/home-api/inforamtion';
import OtpVerification from '../../components/otp-validation/OtpVerification';
import RegisterDataContext from '../../contexts/registerData-context/RegisterDataProvider';

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: '#283C47',
      borderColor: '#283C47'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#283C47'
      },
      '&:hover fieldset': {
        borderColor: '#283C47'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#283C47'
      }
    }
  }
})(TextField);

const ContactForm = ({ selectedData }) => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const [active, setActive] = useState(false);
  const ref = useRef(null);

  const [selectedActivity_id, setSelectedActivity_id] = useState(0);
  const [packagesData, setPackages] = useState([]);
  const [isActive, setIsActive] = useState(0);
  const [PosMonthPrice, setPosMonthPrice] = useState(1);
  const [PosYearPrice, setPosYearPrice] = useState(1);
  const [PosMonthPriceStart, setPosMonthPriceStart] = useState(1);
  const [PosYearPriceStart, setPosYearPriceStart] = useState(1);
  const [initalaboutUsData, setinitalAboutUs] = useState(0);
  const [DisabledValue, setDisabledValue] = useState(0);
  const [DisabledId, setDisabledId] = useState(0);
  const [Discount, setDiscount] = useState('');
  const [Disabled, setDisabled] = useState(true);
  const [posPrice, setPosPrice] = useState(1);
  const [posCount, setPosCount] = useState(0);
  const [pakadgePrice, setPakadgePrice] = useState(0);
  const [totlePrice, setTotlePrice] = useState(0);
  const [showOtp, setShowOtp] = useState(false);
  const [date, setDate] = useState(0);
  // const [name, setName] = useState();
  // const { time, setTime } = useContext(RegisterDataContext);

  // Handle Url
  const params = window.location.search;
  const package_id = params.includes('package_id')
    ? params.split('?')[1].split('&')[0]?.split('=')[1]
    : 1;
  const offer = params.includes('offer') && params.split('?')[1].split('&')[1]?.split('=')[1];
  const [activity_id, setActivity_id] = useState(
    (package_id == 3 || package_id == 4) && offer ? 2 : 0
  );
  const SetAccept = () => () => {
    setActive((prevState) => !prevState);
  };

  useEffect(() => {
    const fetchPosPrice = async () => {
      try {
        const fetchedData = await information(i18n.language);
        if (!fetchedData) {
        } else {
          setinitalAboutUs(parseFloat(fetchedData.pos_price));
          setPosPrice(parseFloat(fetchedData.pos_price));
          setPosMonthPrice(parseFloat(fetchedData.pos_price));
          setPosYearPrice(parseFloat(fetchedData.pos_price_year));
          setPosMonthPriceStart(parseFloat(fetchedData.pos_price));
          setPosYearPriceStart(parseFloat(fetchedData.pos_price_year));
        }
      } catch (error) {}
    };
    fetchPosPrice();

    const fetchPackages = async () => {
      try {
        const fetchedData = await packages(i18n.language);
        if (!fetchedData) {
        } else {
          setPackages(fetchedData.filter((c) => c.id == package_id));
        }
        setSelectedActivity_id(selectedData.activity_id);
      } catch (error) {}
    };

    fetchPackages();
  }, [i18n.language]);

  const baseFormStr = 'request_project_page.request_project_form';
  // let CONTACT_FORM_SCHEMA;
  const CONTACT_FORM_SCHEMA = Yup.object().shape({
    // activity: Yup.string().required(t(`${baseFormStr}.activity.errors.required`)),
    first_name: Yup.string().required('أدخل الاسـم'),
    // activity_id: Yup.string().required(t(`${baseFormStr}.activity_id.errors.required`)),
    // address: Yup.string()
    //   .required(t(`${baseFormStr}.email_address.errors.required`))
    //   .email(t(`${baseFormStr}.email_address.errors.type_error`)),
    // first_name: Yup.string().required('أدخل الاسـم'),
    phone_number: Yup.string()
      .required(t(`${baseFormStr}.phone_number.errors.required`))
      .matches(/^((05))[0-9]{8}$/, t(`${baseFormStr}.phone_number.errors.05number`))
      .min(9, t(`${baseFormStr}.phone_number.errors.less9`))
      .max(10, t(`${baseFormStr}.phone_number.errors.more10`)),

    // tax_number: Yup.string().matches(/^[0-9]+$/, t(`${baseFormStr}.tax.errors.number`)),
    // commercialRecord: Yup.string().matches(/^[0-9]+$/, t(`${baseFormStr}.tax.errors.number`)),
    activity: Yup.string().required(t(`${baseFormStr}.activity.errors.required`))
    // password: Yup.string().required(t(`${baseFormStr}.password.errors.required`))
  });

  const renderAboutUs = () => {
    if (package_id === '1' || package_id > '4') {
      return <p className="section_desc">{t('login_section.login_desc')}</p>;
    }
  };

  //two check boxes
  // const rendercheck = () => {
  //   // if (package_id === '1') {
  //   return (
  //     <div className="form-field-wrapper tow">
  //       <div
  //         className={`check-box ${
  //           activity_id === 1 || selectedActivity_id === 1 ? 'active' : 'noactive'
  //         }  ${opationText === true ? 'selectText' : ''}`}
  //         onClick={Setcheck(1)}>
  //         <div
  //           className={`large_Box ${
  //             activity_id === 1 || selectedActivity_id === 1 ? 'active' : 'noactive'
  //           }`}></div>
  //         <div>
  //           <p className="title">{t(`${baseFormStr}.activity_id.label2`)}</p>

  //           {t(`${baseFormStr}.activity_id.label2desc`)}
  //         </div>
  //       </div>
  //       <div
  //         className={`check-box ${
  //           activity_id === 2 || selectedActivity_id === 2 ? 'active' : 'noactive'
  //         }`}
  //         onClick={Setcheck(2)}>
  //         <div
  //           className={`large_Box ${
  //             activity_id === 2 || selectedActivity_id === 2 ? 'active' : 'noactive'
  //           }`}></div>
  //         <div>
  //           <p className="title">{t(`${baseFormStr}.activity_id.label3`)}</p>

  //           {t(`${baseFormStr}.activity_id.label3desc`)}
  //         </div>
  //       </div>
  //     </div>
  //   );
  //   // }
  // };

  const ChangePos = (event) => {
    if (package_id === '2') {
      if (event.target.value !== '') {
        setPosCount(parseFloat(event.target.value));
        setinitalAboutUs(parseFloat(PosMonthPriceStart) * parseFloat(event.target.value));
        PosMonthPrice(parseFloat(PosMonthPriceStart) * parseFloat(event.target.value));
        setTotlePrice(
          parseFloat(PosMonthPriceStart) * parseFloat(event.target.value) +
            parseFloat(pakadgePrice) -
            DisabledValue
        );
      } else {
        setPosCount(0);

        setinitalAboutUs(parseFloat(PosMonthPriceStart));
        setTotlePrice(parseFloat(PosMonthPriceStart) + parseFloat(pakadgePrice) - DisabledValue);
      }
    } else if (package_id === '3') {
      if (event.target.value !== '') {
        setPosCount(parseFloat(event.target.value));
        setinitalAboutUs(parseFloat(PosMonthPriceStart) * parseFloat(event.target.value));
        PosMonthPrice(parseFloat(PosMonthPriceStart) * parseFloat(event.target.value));
        setTotlePrice(
          parseFloat(PosMonthPriceStart) * parseFloat(event.target.value) +
            parseFloat(pakadgePrice) -
            DisabledValue
        );
      } else {
        setPosCount(0);

        setinitalAboutUs(parseFloat(PosMonthPriceStart));
        setTotlePrice(parseFloat(PosMonthPriceStart) + parseFloat(pakadgePrice) - DisabledValue);
      }
    } else if (package_id === '4') {
      if (event.target.value !== '') {
        setPosCount(parseFloat(event.target.value));
        setinitalAboutUs(parseFloat(PosYearPriceStart) * parseFloat(event.target.value));
        PosYearPrice(parseFloat(PosYearPriceStart) * parseFloat(event.target.value));
        setTotlePrice(
          parseFloat(PosYearPriceStart) * parseFloat(event.target.value) +
            parseFloat(pakadgePrice) -
            DisabledValue
        );
      } else {
        setPosCount(0);

        setinitalAboutUs(parseFloat(PosYearPriceStart));
        setTotlePrice(parseFloat(PosYearPriceStart) + parseFloat(pakadgePrice) - DisabledValue);
      }
    }
  };

  const plusPos = () => () => {
    if (package_id === '2') {
      setPosCount((prevState) => prevState + 1);
      setinitalAboutUs(parseFloat(PosMonthPriceStart) * 1 * (posCount + 1));
      setPosMonthPrice(parseFloat(PosMonthPriceStart) * 1 * (posCount + 1));

      setTotlePrice(
        parseFloat(PosMonthPriceStart) * 1 * (posCount + 1) +
          parseFloat(pakadgePrice) -
          DisabledValue
      );
    } else if (package_id === '3') {
      setPosCount((prevState) => prevState + 1);
      setinitalAboutUs(parseFloat(PosMonthPriceStart) * 3 * (posCount + 1));
      setPosMonthPrice(parseFloat(PosMonthPriceStart) * 3 * (posCount + 1));

      setTotlePrice(
        parseFloat(PosMonthPriceStart) * 6 * (posCount + 1) +
          parseFloat(pakadgePrice) -
          DisabledValue
      );
    } else if (package_id === '4') {
      setPosCount((prevState) => prevState + 1);
      setinitalAboutUs(parseFloat(PosMonthPriceStart) * 12 * (posCount + 1));
      setPosMonthPrice(PosMonthPriceStart * 12 * (posCount + 1));

      setTotlePrice(
        parseFloat(PosMonthPriceStart) * 12 * (posCount + 1) +
          parseFloat(pakadgePrice) -
          DisabledValue
      );
    }
  };

  const minsPos = () => () => {
    if (package_id === '2') {
      if (posCount > 0) {
        setPosCount((prevState) => prevState - 1);
        setinitalAboutUs(PosMonthPriceStart * 1 * (posCount - 1));

        setPosMonthPrice(PosMonthPriceStart * 1 * (posCount - 1));

        setTotlePrice(
          parseFloat(PosMonthPriceStart) * 1 * (posCount - 1) +
            parseFloat(pakadgePrice) -
            DisabledValue
        );
      }
    } else if (package_id === '3') {
      if (posCount > 0) {
        setPosCount((prevState) => prevState - 1);
        setinitalAboutUs(PosMonthPriceStart * 6 * (posCount - 1));

        setPosMonthPrice(PosMonthPriceStart * 6 * (posCount - 1));

        setTotlePrice(
          parseFloat(PosMonthPriceStart) * 6 * (posCount - 1) +
            parseFloat(pakadgePrice) -
            DisabledValue
        );
      }
    } else if (package_id === '4') {
      if (posCount > 0) {
        setPosCount((prevState) => prevState - 1);
        setinitalAboutUs(PosMonthPriceStart * 12 * (posCount - 1));

        setPosMonthPrice(PosMonthPriceStart * 12 * (posCount - 1));

        setTotlePrice(
          parseFloat(PosMonthPriceStart) * 12 * (posCount - 1) +
            parseFloat(pakadgePrice) -
            DisabledValue
        );
      }
    }
  };

  const ChangeDiscount = (event) => {
    if (event.target.value !== '' && totlePrice > 0) {
      setDiscount(event.target.value);
      setDisabled(false);
    } else {
      setDiscount('');
      setDisabled(true);
    }
  };

  const GetCodeValue = (data) => {
    setDisabledId(data.id);
    // setPrePakadgeId(isActive);
    let disCountValue =
      parseFloat(packagesData[0].price * packagesData[0]?.monthNumber) *
      (parseFloat(data.discount) / 100);
    // console.log((parseFloat(data.discount) / 100));
    setDisabledValue(
      parseFloat(packagesData[0].price * packagesData[0]?.monthNumber) *
        (parseFloat(data.discount) / 100)
    );
    setTotlePrice(totlePrice - disCountValue);

    // totlePrice > 0 &&
    //   store.addNotification({
    //     title: `${t('')}`,
    //     message: `${t('تم الخصم بنجاح')}`,
    //     type: 'success',
    //     insert: 'top',
    //     container: 'top-right',
    //     animationIn: ['animate__animated', 'animate__fadeIn'],
    //     animationOut: ['animate__animated', 'animate__fadeOut'],
    //     dismiss: {
    //       duration: 4000,
    //       showIcon: true,
    //       onScreen: true
    //     }
    //   });
  };

  const [phone, setPhone] = useState();
  const [userObj, setUserObj] = useState(
    Cookies.get('currentUser') ? JSON.parse(Cookies.get('currentUser')) : {}
  );

  useEffect(() => {
    if (Cookies.get('currentUser')) {
      setUserObj(JSON.parse(Cookies.get('currentUser')));
    }
  }, []);
  const ApplyDiscount = async () => {
    try {
      const getAdminRes = await discount(
        i18n.language,
        Discount,
        package_id,
        activity_id,
        ref?.current?.values?.phone_number
      );
      if (ref?.current?.values?.phone_number) {
        if (getAdminRes.status === 200 && getAdminRes?.data?.data && getAdminRes?.data?.success) {
          store.addNotification({
            title: getAdminRes?.data?.message,
            message: `${t('تم الخصم بنجاح')}`,
            type: 'success',
            insert: 'top',
            container: 'top-right',
            animationIn: ['animate__animated', 'animate__fadeIn'],
            animationOut: ['animate__animated', 'animate__fadeOut'],
            dismiss: {
              duration: 2000,
              showIcon: true,
              onScreen: true
            }
          });
          setDiscount('');
          setDisabled((prevState) => !prevState);
          GetCodeValue(getAdminRes?.data?.data);
          // debugger
          // if (DisabledId === getAdminRes.data.data.id || DisabledId !== 0) {
          //   store.addNotification({
          //     title: `فشل ف الأرسال`,
          //     message: `${t('Offers_section.cantusemanycode')}`,
          //     type: 'danger',
          //     insert: 'top',
          //     container: 'top-right',
          //     animationIn: ['animate__animated', 'animate__fadeIn'],
          //     animationOut: ['animate__animated', 'animate__fadeOut'],
          //     dismiss: {
          //       duration: 4000,
          //       showIcon: true,
          //       onScreen: true
          //     }
          //   });
          // } else {
          //   store.addNotification({
          //     title: '',
          //     message: getAdminRes?.data?.message,
          //     type: 'success',
          //     insert: 'top',
          //     container: 'top-right',
          //     animationIn: ['animate__animated', 'animate__fadeIn'],
          //     animationOut: ['animate__animated', 'animate__fadeOut'],
          //     dismiss: {
          //       duration: 2000,
          //       showIcon: true,
          //       onScreen: true
          //     }
          //   });
          //   setDiscount('');
          //   setDisabled((prevState) => !prevState);
          //   GetCodeValue(getAdminRes?.data?.data);
          // }
        } else {
          store.addNotification({
            title: `فشل ف الأرسال`,
            message: getAdminRes?.data?.message,
            type: 'danger',
            insert: 'top',
            container: 'top-right',
            animationIn: ['animate__animated', 'animate__fadeIn'],
            animationOut: ['animate__animated', 'animate__fadeOut'],
            dismiss: {
              duration: 4000,
              showIcon: true,
              onScreen: true
            }
          });
        }
      } else {
        store.addNotification({
          title: `أدخل رقم الهاتف أولا`,
          message: getAdminRes?.data?.message,
          type: 'danger',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: 4000,
            showIcon: true,
            onScreen: true
          }
        });
      }
    } catch (error) {}
  };

  const renderPosCount = () => {
    return (
      <div style={{ marginRight: '30px' }}>
        <div
          className={`pos-div ${i18n.dir()} ${
            package_id > 1 && package_id < 5 && activity_id === '1' ? 'Active-pos' : 'notActive-pos'
          }`}>
          <div className={`pos-container ${activity_id === '1' ? 'has-pos' : 'nothas-pos'}`}>
            <div className={`text ${activity_id === 1 ? 'has-pos' : 'nothas-pos'}`}>
              {t(`${baseFormStr}.pos.plus`)}
            </div>
            {/* لزيادة نقاط البيع */}
            <div className="pos-count">
              <div onClick={plusPos()}>
                <img src={plusbg} alt="plusbg" />
              </div>
              <div>
                <input
                  type="number"
                  // defaultValue={posCount}
                  onChange={ChangePos}
                  value={posCount}
                />
              </div>
              <div onClick={minsPos()} className={``}>
                <img src={mins} alt="mins" />
              </div>
            </div>

            <div className={`text-price`}>
              {PosMonthPriceStart} {t('Offers_section.pricepermonth')}
            </div>
          </div>
        </div>
        <div
          style={{ margin: '10px auto' }}
          className={`pos-div discount-div ${i18n.dir()} ${
            package_id > 1 && package_id < 5 && activity_id !== 0 ? 'Active-pos' : 'notActive-pos'
          }`}>
          <div className="pos-container-discount">
            <div className="pos-count div-text">
              <input
                type="text"
                className="Dis"
                onChange={ChangeDiscount}
                value={Discount}
                placeholder={t(`${baseFormStr}.pos.AddDisCount`)}
              />
            </div>
            <div className="pos-count div-text">
              <span
                onClick={() => ApplyDiscount()}
                disabled={Disabled}
                style={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#2e4652',
                  color: '#fff',
                  borderRadius: '10px',
                  width: '100px',
                  // height: '30px',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  textAlign: 'center'
                }}>
                {t(`${baseFormStr}.pos.Add`)}
              </span>
            </div>
          </div>
        </div>
        {totlePrice > 0 && (
          <div className="form-control">
            <div className={`${i18n.dir()} pakage-box paks-link`}>
              <div className="projects-link">
                <span className="total-price">
                  {t('Offers_section.Totleprice')} :
                  {`${totlePrice.toFixed(3)} ${t('Offers_section.price')}`}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const [open, setOpen] = useState(false);
  // const [userId, setUserId] = useState(0);

  const handleClose = () => {
    setOpen(false);
  };
  const SetSelectedCheck = (id) => () => {
    setSelectedActivity_id(id);
  };

  const Setcheck = (id) => () => {
    setActivity_id(id);
    setSelectedActivity_id(id);
    setIsActive(id);
  };
  const Completionist = () => (
    <Button className="btn">
      <a
        href={`http://websiteapi.fatoorah.sa/createNewLink?id=اال`}
        rel="noreferrer"
        onClick={handleClose}>
        <span className="btn-span">{t('create_project.complate_payment')}</span>
      </a>
    </Button>
  );

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a complete state
      return <Completionist />;
    } else {
      // Render a countdown
      return (
        <span className="wait">
          {t('create_project.wait')} {seconds}
        </span>
      );
    }
  };

  useEffect(() => {
    setPakadgePrice(
      packagesData[0]?.price *
        packagesData[0]?.monthNumber *
        ((package_id == 3 || package_id == 4) && offer ? 50 / 100 : 1)
    );
    setTotlePrice(
      packagesData[0]?.price *
        packagesData[0]?.monthNumber *
        ((package_id == 3 || package_id == 4) && offer ? 50 / 100 : 1)
    );
  }, [packagesData[0]?.price]);

  const [opationText, setOpationText] = useState(false);

  const handleChange = (value, args) => {
    args.setFieldValue('activity', value.value);
    setActivity_id(JSON.stringify(value.value));
    setSelectedActivity_id(JSON.stringify(value.value));
    setIsActive(JSON.stringify(value.value));
  };

  return (
    <Formik
      innerRef={ref}
      initialValues={{
        first_name: userObj && userObj.first_name ? userObj.first_name : '',
        activity: activity_id || '',
        phone_number: userObj ? userObj.phone_number : '',
        address: userObj ? userObj.address : '',
        tax_number: userObj && userObj.tax_number ? userObj.tax_number : '',
        commercialRecord: userObj && userObj.commercialRecord ? userObj.commercialRecord : ''
      }}
      onSubmit={async (values, { setSubmitting, resetForm }) => {
        try {
          if (active) {
            if (package_id != '1' && package_id < '5') {
              Cookies.set('currentUser', values, {
                sameSite: 'strict'
              });
              const fetchedData = await requestProject(
                values,
                activity_id,
                i18n.language,
                package_id || 1,
                posCount,
                totlePrice.toFixed(3),
                DisabledValue,
                DisabledId,
                null,
                0
              );

              if (fetchedData && fetchedData.success) {
                setDate(Date.now());
                setSubmitting(false);
                resetForm();

                // history.push(routerLinks.OtpVerification, {
                //   selectedPakage: package_id,
                //   TotlePrice: totlePrice,
                //   PosCount: posCount,
                //   DisabledId: DisabledId,
                //   DisabledValue: DisabledValue,
                //   activity_id: activity_id,
                //   sollemKey: null,
                //   values: values
                // });
                // setShowOtp(true);
                let data = fetchedData.data;
                if (data?.package_id === 1) {
                  if (data.activity == 1) {
                    setTimeout(() => {
                      window.location.replace('https://fatoorah.fatoorah.sa/');
                    }, 2000);
                  } else if (data.activity == 2) {
                    setTimeout(() => {
                      window.location.replace('https://services.fatoorah.sa/');
                    }, 2000);
                  }
                } else {
                  window.location.replace(data?.redirect_url);
                }
                store.addNotification({
                  title: '',
                  message: fetchedData.message,
                  type: 'success',
                  insert: 'top',
                  container: 'top-right',
                  animationIn: ['animate__animated', 'animate__fadeIn'],
                  animationOut: ['animate__animated', 'animate__fadeOut'],
                  dismiss: {
                    duration: 2000,
                    showIcon: true,
                    onScreen: true
                  }
                });
              } else {
                setSubmitting(false);
                setShowOtp(false);
                store.addNotification({
                  title: `${t(
                    'request_project_page.request_project_form.send_btn.title_message_error'
                  )}`,
                  message: fetchedData.message,
                  type: 'danger',
                  insert: 'top',
                  container: 'top-right',
                  animationIn: ['animate__animated', 'animate__fadeIn'],
                  animationOut: ['animate__animated', 'animate__fadeOut'],
                  dismiss: {
                    duration: 5000,
                    showIcon: true,
                    onScreen: true
                  }
                });
              }
              // history.push(routerLinks.payPage, {
              //   selectedPakage: package_id,
              //   TotlePrice: totlePrice,
              //   PosCount: posCount,
              //   DisabledId: DisabledId,
              //   DisabledValue: DisabledValue,
              //   activity_id: activity_id,
              //   sollemKey: null,
              //   values: values
              // });
            } else {
              if (activity_id === 0) {
                setOpationText(true);
              } else {
                setSubmitting(true);
                await sleep(500);
                const fetchedData = await requestProject(
                  values,
                  activity_id,
                  i18n.language,
                  package_id,
                  // (package_id === undefined || package_id > 4 || package_id === '1') && '1',
                  posCount,
                  DisabledValue,
                  DisabledId,
                  null,
                  0
                );

                if (fetchedData && fetchedData.success) {
                  setDate(Date.now());
                  setSubmitting(false);
                  resetForm();
                  // if (activity_id === 1 || activity_id === 2) {
                  //   console.log('inside');
                  //   // window.location.replace('https://fatoorah.sa/thank-you/');
                  //   // Break point
                  // }
                  Cookies.set('currentUser', values, {
                    sameSite: 'strict'
                  });
                  // history.push(routerLinks.OtpVerification);
                  // setShowOtp(true);
                  let data = fetchedData.data;
                  if (data.activity == 1) {
                    setTimeout(() => {
                      window.location.replace('https://fatoorah.fatoorah.sa/');
                    }, 2000);
                  } else if (data.activity == 2) {
                    setTimeout(() => {
                      window.location.replace('https://services.fatoorah.sa/');
                    }, 2000);
                  }
                  store.addNotification({
                    title: '',
                    message: fetchedData.message,
                    type: 'success',
                    insert: 'top',
                    container: 'top-right',
                    animationIn: ['animate__animated', 'animate__fadeIn'],
                    animationOut: ['animate__animated', 'animate__fadeOut'],
                    dismiss: {
                      duration: 2000,
                      showIcon: true,
                      onScreen: true
                    }
                  });
                } else {
                  setSubmitting(false);

                  store.addNotification({
                    title: `${t(
                      'request_project_page.request_project_form.send_btn.title_message_error'
                    )}`,
                    message: fetchedData.message,
                    type: 'danger',
                    insert: 'top',
                    container: 'top-right',
                    animationIn: ['animate__animated', 'animate__fadeIn'],
                    animationOut: ['animate__animated', 'animate__fadeOut'],
                    dismiss: {
                      duration: 5000,
                      showIcon: true,
                      onScreen: true
                    }
                  });
                }
              }
            }
          } else {
            setSubmitting(false);
            store.addNotification({
              // title: `${t('request_project_page.request_project_form.send_btn.title_message_error')}`,
              message: `${t('request_project_page.request_project_form.send_btn.Accept')}`,
              type: 'danger',
              insert: 'top',
              container: 'top-right',
              animationIn: ['animate__animated', 'animate__fadeIn'],
              animationOut: ['animate__animated', 'animate__fadeOut'],
              dismiss: {
                duration: 5000,
                showIcon: true,
                onScreen: true
              }
            });
          }
        } catch (error) {
          setSubmitting(false);
          store.addNotification({
            title: `${t('request_project_page.request_project_form.send_btn.title_message_error')}`,
            message: 'حاول فى وقت لاحق',
            type: 'danger',
            insert: 'top',
            container: 'top-right',
            animationIn: ['animate__animated', 'animate__fadeIn'],
            animationOut: ['animate__animated', 'animate__fadeOut'],
            dismiss: {
              duration: 5000,
              showIcon: true,
              onScreen: true
            }
          });
        }
      }}
      validationSchema={CONTACT_FORM_SCHEMA}>
      {({
        values,
        isSubmitting,
        handleSubmit,
        errors,
        touched,
        setSubmitting,
        resetForm,
        ...args
      }) => {
        return (
          <>
            {showOtp === false && (
              <form
                onSubmit={handleSubmit}
                className={`contact-form ${i18n.dir()}`}
                id="contact-form">
                <div className="features-item-header ">
                  <h1 className="h1-text section_header">{t('login_section.main_title')}</h1>
                  {(package_id == 3 || package_id == 4) && offer && (
                    <div className="section_header-offer">
                      <h2>خصم 50% على باقتنا بمناسبة الجمعة البيضاء</h2>
                      <h4>لا يوجد استرجاع بعد الدفع في حالة شراء العرض</h4>
                    </div>
                  )}
                  {renderAboutUs()}
                </div>
                {package_id && packagesData[0]?.price && package_id === '2' && (
                  <div className="package-info">
                    <h4>{t('login_section.package')}</h4>
                    <p>{`${packagesData[0]?.price} ${t('login_section.packageSelected')} ${
                      packagesData[0]?.name
                    }`}</p>
                    <p className="total-price">
                      {`${t('login_section.totalPrice')}: ${packagesData[0]?.price} ${t(
                        'login_section.packageSAR'
                      )}`}
                    </p>
                  </div>
                )}
                {package_id && packagesData[0]?.price && package_id === '3' && (
                  <div className="package-info">
                    <h4>{t('login_section.package')}</h4>
                    <p>{`${packagesData[0]?.price} ${t('login_section.packageSelected')} ${
                      packagesData[0]?.name
                    }`}</p>
                    <p className="total-price">
                      {`${t('login_section.totalPrice')}: ${
                        packagesData[0]?.price * packagesData[0]?.monthNumber
                      }  ${t('login_section.packageSAR')}`}
                    </p>
                  </div>
                )}
                {package_id && packagesData[0]?.price && package_id === '4' && (
                  <div className="package-info">
                    <h4>{t('login_section.package')}</h4>
                    <p>{`${packagesData[0]?.price} ${t('login_section.packageSelected')} ${
                      packagesData[0]?.name
                    }`}</p>
                    <p className="total-price">
                      {`${t('login_section.totalPrice')}: ${
                        packagesData[0]?.price * packagesData[0]?.monthNumber
                      }  ${t('login_section.packageSAR')}`}
                    </p>
                  </div>
                )}

                <div className="form-selector-wrapper ddd">
                  {/* <p
                  className={`field-label 
                      ${opationText === true ? 'selectTextdisplay' : 'selectTextdisplaynot'}`}>
                  {t('request_project_page.request_project_form.send_btn.Choosetype')}
                </p> */}
                  <img src={juggling} alt="EmailIcon" />

                  <Select
                    name="activity"
                    styles={{ textAlign: 'right', marginBottom: '20px' }}
                    placeholder={'إختر نوع الخدمة'}
                    onChange={(e) => handleChange(e, args)}
                    options={
                      !offer
                        ? [
                            { value: 1, label: t(`${baseFormStr}.activity_id.label2`) },
                            { value: 2, label: t(`${baseFormStr}.activity_id.label3`) }
                          ]
                        : package_id == 3 || package_id == 4
                        ? [{ value: 2, label: t(`${baseFormStr}.activity_id.label3`) }]
                        : [
                            { value: 1, label: t(`${baseFormStr}.activity_id.label2`) },
                            { value: 2, label: t(`${baseFormStr}.activity_id.label3`) }
                          ]
                    }
                    // isDisabled={offer ? true : false}
                    // value={(package_id == 3 || package_id == 4) && offer && {value: 2, label: t(`${baseFormStr}.activity_id.label3`)}}
                    defaultValue={
                      (package_id == 3 || package_id == 4) &&
                      offer && { value: 2, label: t(`${baseFormStr}.activity_id.label3`) }
                    }
                  />
                </div>
                {renderPosCount()}

                <div className="form-field-wrapper ddd">
                  {/* <p className="field-label">{t(`${baseFormStr}.first_name.label`)}</p> */}
                  <img src={user} alt="user" />
                  <Field
                    component={CssTextField}
                    // value={name}
                    // onChange={(e) => setName(e.target.value)}
                    name="first_name"
                    type="text"
                    variant="outlined"
                    // color="primary"
                    className="form-field"
                    label={t(`${baseFormStr}.first_name.label`)}
                    // required
                    // InputProps={{
                    //   startAdornment: (
                    //     <InputAdornment position="end">
                    //       <img src={user} alt="EmailIcon" />
                    //     </InputAdornment>
                    //   )
                    // }}
                  />
                </div>
                {/* <p className="field-label">{t(`${baseFormStr}.email_address.label`)}</p> */}
                {/* <div className="form-field-wrapper ddd">
                <img src={EmailIcon} alt="EmailIcon" />
                <Field
                  component={CssTextField}
                  name="address"
                  type="email"
                  variant="outlined"
                  color="primary"
                  className="form-field"
                  label={t(`${baseFormStr}.email_address.label`)}
                />
              </div> */}
                <div className="form-field-wrapper ddd">
                  {/* <p className="field-label">{t(`${baseFormStr}.phone_number.label`)}</p> */}
                  <img src={call} alt="EmailIcon" />
                  <Field
                    component={CssTextField}
                    name="phone_number"
                    type="text"
                    variant="outlined"
                    color="primary"
                    className="form-field"
                    label="05xxxxxxxx"
                    // InputProps={{
                    //   startAdornment: (
                    //     <InputAdornment position="end">
                    //       <img src={call} alt="EmailIcon" />
                    //     </InputAdornment>
                    //   )
                    // }}
                  />
                </div>
                {/* <div className="form-field-wrapper ddd">
                <img src={passwordImg} alt="password" />
                <Field
                  component={CssTextField}
                  name="password"
                  type="password"
                  variant="outlined"
                  color="primary"
                  className="form-field"
                  label={t(`${baseFormStr}.password.label`)}
                  // InputProps={{
                  //   startAdornment: (
                  //     <InputAdornment position="end">
                  //       <img src={passwordImg} alt="password" />
                  //     </InputAdornment>
                  //   )
                  // }}
                />
              </div> */}
                <div className="form-field-wrapper ddd accepect">
                  <div
                    className={`large_Box ${active ? 'active' : 'noactive'}`}
                    onClick={SetAccept()}>
                    <img src={check} alt="check" />
                  </div>
                  <div className="hepar">
                    <span>{t('Offers_section.Accept')} &nbsp;</span>
                    <span>
                      <a
                        target="_blank"
                        href={'https://fatoorah.sa/terms-and-conditions/'}
                        rel="noreferrer">
                        {t('Offers_section.TremsCondition')}
                      </a>
                    </span>
                    <span>&nbsp;{t('Offers_section.and')} &nbsp;</span>
                    <span>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={'https://fatoorah.sa/privacy-policy/'}>
                        {t('Offers_section.Policy')}
                      </a>
                    </span>
                  </div>
                </div>

                <div className="form-field-wrapper ddd project-details-field-wrap fffff">
                  {activity_id ? (
                    <ButtonWithLoading
                      isSubmitting={isSubmitting}
                      errors={errors}
                      btnText={`${
                        history?.location?.state?.selectedPakage !== 1
                          ? t(`${baseFormStr}.Pay.title`)
                          : t(`${baseFormStr}.send_btn.title`)
                      }`}
                      loadingMsg={`${
                        history?.location?.state?.selectedPakage !== 1
                          ? t(`${baseFormStr}.Pay.loading`)
                          : t(`${baseFormStr}.send_btn.loading`)
                      }`}
                      className="submit-btn submit-form-btn"
                      form="contact-form"
                    />
                  ) : (
                    <ButtonWithLoading
                      isSubmitting={isSubmitting}
                      errors={errors}
                      disabled
                      btnText={`${
                        history?.location?.state?.selectedPakage !== 1
                          ? t(`${baseFormStr}.Pay.title`)
                          : t(`${baseFormStr}.send_btn.title`)
                      }`}
                      loadingMsg={`${
                        history?.location?.state?.selectedPakage !== 1
                          ? t(`${baseFormStr}.Pay.loading`)
                          : t(`${baseFormStr}.send_btn.loading`)
                      }`}
                      className="submit-btn submit-form-btn"
                      form="contact-form"
                    />
                  )}
                </div>
              </form>
            )}
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description">
              <div className={`modal ${i18n.dir()}`}>
                <Button onClick={handleClose} justify="center" className="close">
                  <img src={close} alt="close" width="20" height="20" />
                </Button>
                <div className="text">{t('create_project.notcomplate_payment')}</div>
                <Countdown date={Date.now() + 60000} renderer={renderer} />
              </div>
            </Modal>
            {showOtp && (
              <OtpVerification
                package_id={package_id}
                totlePrice={totlePrice}
                posCount={posCount}
                DisabledId={DisabledId}
                DisabledValue={DisabledValue}
                activity_id={activity_id}
                sollemKey={null}
                values={values}
                date={date}
                // onClick={()=>{setShowOtp(false)}}
              />
            )}
          </>
        );
      }}
    </Formik>
  );
};

export default ContactForm;
